import { render, staticRenderFns } from "./SparePartLogsDetail.vue?vue&type=template&id=1c7f889e&scoped=true&"
import script from "./SparePartLogsDetail.vue?vue&type=script&lang=js&"
export * from "./SparePartLogsDetail.vue?vue&type=script&lang=js&"
import style0 from "./SparePartLogsDetail.vue?vue&type=style&index=0&id=1c7f889e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7f889e",
  null
  
)

export default component.exports